import { JSX } from "react";
import { DownloadItemTypeEnum } from "../../../../enums/DownloadItemTypeEnum";
import { downloadFile } from "../../../../utils/Export";
import {
    formatDownloadFileName,
    ProductDownloadFile,
} from "../../../../utils/productDetail/buildProductDownloadEntries";
import { SvgDownload } from "../../../svg/SvgDownload";

interface Props {
    file: ProductDownloadFile;
}

export const ProductDownloadLink = ({ file }: Props): JSX.Element => {
    const label = formatDownloadFileName(file.name, file.type);

    const content = (
        <>
            <SvgDownload color="#151112" />
            <span>{label}</span>
        </>
    );

    if (file.type === DownloadItemTypeEnum.videos) {
        return (
            <a
                className="c-product-downloads__link"
                href={file.url}
                target="_blank"
                rel="noreferrer"
            >
                {content}
            </a>
        );
    }

    return (
        <button
            type="button"
            className="c-product-downloads__link"
            onClick={() =>
                downloadFile({
                    url: file.url,
                    fileName: label,
                    extension: file.extension,
                })
            }
        >
            {content}
        </button>
    );
};
